module.exports = __webpack_public_path__ + "img/202308_03.70cc4288.jpg";